<template>
  <main :id="$style.main">
    <main-title
      :class="$style.main_title"
      :main_title="'夢郵便'"
      :sub_title="'〜 Dream Post 〜'"
      :color="'#192C58'"
      :align="'center'"
    ></main-title>
    <div :id="$style.caption">
      係りから「夢郵便はがき」投函の皆様へ
      あなた自身に宛てた「夢郵便はがき」を楽しく微笑ましく拝見させて戴いています。
      きっとホームページ閲覧のみなさんも同じと思います。
      素敵な夢郵便ハガキの数々誠にありがとうございます。
      <br />
      <br />係りでは、夢郵便ハガキを投函されました皆様に抽選で、松井選手直筆のサイン色紙を10名様(年間)に
      プレゼントさせて戴いています。尚、当選の発表は(毎年2月下旬)発送をもって代えさせて戴きます。
    </div>
    <more-info-big-button
      :title="'応募の詳細はこちら'"
      :color="'#fff'"
      :background="'#75A2A0'"
      :link="'/dreampost/detail'"
    ></more-info-big-button>

    <dream-post-menu></dream-post-menu>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import MoreInfoBigButton from "@/components/atoms/MoreInfoBigButton.vue";
import DreamPostMenu from "@/components/organsms/dream_post/DreamPostMenu.vue";

export default Vue.extend({
  name: "DreamPostView",

  components: {
    MainTitle,
    MoreInfoBigButton,
    DreamPostMenu
  }
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #main {
    background-color: #e0f5e7;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    #caption {
      text-align: center;
      margin: 40px 15px;
      color: #403f3f;
      font-size: 14px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #main {
    background-color: #e0f5e7;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    #caption {
      text-align: center;
      width: 800px;
      margin: 40px 0;
      color: #403f3f;
    }
  }
}
</style>
